import {MAX_AGE, MAX_CACHE_AGE_HOME, MAX_CACHE_AGE_PRODUCT, STALE_WHILE_REVALIDATE} from '../data/constants'

/**
 * @name setContentPageCacheHeaders
 *
 * @description
 * Sets standard Cache-Control headers for content pages (Home, Editorial, etc.).
 * Uses the same cache durations across all content pages for consistency.
 *
 * @param res - The SSR response object from useServerContext()
 */
function setContentPageCacheHeaders(res: {set: (name: string, value: string) => void}): void {
    res.set('Cache-Control', `max-age=${MAX_AGE}, s-maxage=${MAX_CACHE_AGE_HOME}, stale-while-revalidate=${STALE_WHILE_REVALIDATE}`)
}

/**
 * @name setProductPageCacheHeaders
 *
 * @description
 * Sets Cache-Control headers for product detail pages (PDP).
 * Uses a shorter s-maxage than content pages (Home, Editorial) because
 * product data (pricing, availability) changes more frequently.
 *
 * @param res - The SSR response object from useServerContext()
 */
function setProductPageCacheHeaders(res: {set: (name: string, value: string) => void}): void {
    res.set(
        'Cache-Control',
        `max-age=${MAX_AGE}, s-maxage=${MAX_CACHE_AGE_PRODUCT}, stale-while-revalidate=${STALE_WHILE_REVALIDATE}`,
    )
}

export {setContentPageCacheHeaders, setProductPageCacheHeaders}
